import type { ReactNode } from "react";
import { WaitlistContext, useWaitlistController } from "../hooks/useWaitlistForm";

interface WaitlistProviderProps {
  children: ReactNode;
}

export function WaitlistProvider({ children }: WaitlistProviderProps) {
  const value = useWaitlistController();
  return <WaitlistContext.Provider value={value}>{children}</WaitlistContext.Provider>;
}
